import * as React from "react";
const SvgFiRrCommentPen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-comment-pen_svg__a)">
      <path
        fill="#062147"
        d="M8.586 18H7a1 1 0 0 1-1-1v-1.586c0-1.068.416-2.073 1.172-2.828l5.707-5.707A3.002 3.002 0 0 1 17.999 9c0 .801-.312 1.555-.878 2.122l-5.707 5.707A3.97 3.97 0 0 1 8.586 18M8 16h.586c.534 0 1.036-.208 1.414-.586l5.707-5.707A1 1 0 0 0 16 9a1 1 0 0 0-1.707-.707L8.586 14A2.02 2.02 0 0 0 8 15.414zm11 8h-5.917C6.082 24 .47 19.208.029 12.854a12.03 12.03 0 0 1 3.48-9.333A12.04 12.04 0 0 1 12.836.03C19.096.454 24 5.862 24 12.341v6.66a5.005 5.005 0 0 1-5 5M12.015 2.001a10.02 10.02 0 0 0-7.091 2.933 10.02 10.02 0 0 0-2.898 7.782c.372 5.38 5.023 9.285 11.058 9.285H19c1.654 0 3-1.346 3-3v-6.66c0-5.43-4.085-9.962-9.3-10.316a10 10 0 0 0-.686-.023"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-comment-pen_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCommentPen;
